import React from "react";
import { Col, Row } from "reactstrap";
import { useProfile } from "Components/Hooks/UserHooks";
import useQueryState from "Components/Hooks/UseQueryState";

const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 5 }, (_, index) => {
    const year = currentYear - index;
    return { value: year.toString(), label: year.toString() };
  });
};
const currentYear = new Date().getFullYear().toString();

const Section = (props: any) => {
  const options = React.useMemo(() => generateYearOptions(), []);

  const [selectedYear, setSelectedYear] = useQueryState("year", currentYear);

  const { userProfile } = useProfile();

  return (
    <React.Fragment>
      <Row className="mb-3 pb-1">
        <Col xs={12}>
          <div className="d-flex align-items-lg-center flex-lg-row flex-column">
            <div className="flex-grow-1">
              Welcome back, {`${userProfile?.firstName}`}!
              <p className="text-muted mb-0">
                Here's what's happening in CIRT.
              </p>
            </div>
            <div className="mt-3 mt-lg-0 d-flex align-items-center justify-content-center">
              {/* <label className="mb-0 me-2">Year of analysis:</label> */}
              {/* @ts-ignore */}
              <select
                className="form-control w-auto"
                data-choices
                data-choices-search-false
                name="choices-single-default2"
                id="choices-single-default2"
                onChange={(e) => {
                  setSelectedYear(e.target.value);
                }}
                value={selectedYear}
              >
                {/* <option value="">Select Year</option> */}
                <option value="all">Year of analysis - All</option>
                {options.map((option: any) => (
                  <option key={option.value} value={option.value}>
                    Year of analysis - {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Section;
